<template>
  <div>
    <Row :gutter="4">
      <div v-if="company == 1">
        <Col span="6">
          <Select
            v-model="companyIdSearch"
            filterable
            :placeholder="$t('alarms.common.pleaseSelectCompany')"
            :transfer="true"
            @on-change="changeCompany"
          >
            <Option
              :value="item.id"
              v-for="item in companyList"
              :key="item.id"
              >{{ item.name }}</Option
            >
          </Select>
        </Col>
      </div>
      <Col span="6">
        <!-- v-on:input实时查询 -->
        <Input
          search
          v-model="searchKey"
          @on-search="search()"
          :placeholder="$t('tag.pleaseInputTag')"
        />
      </Col>
      <Col span="4">
        <Button
          type="primary"
          v-hasPermission="['labelManagement:tag:add']"
          @click="addTagModalVisible = true"
          >{{ $t("alarms.common.add") }}</Button
        >
      </Col>
    </Row>
    <!-- 添加标签 -->
    <Modal
      v-model="addTagModalVisible"
      :title="$t('tag.addTag')"
      @on-ok="addTagSubmit('addTagForm')"
      @on-cancel="addTagReset('addTagForm')"
      :loading="loadingAdd"
      :mask-closable="false"
      :okText="$t('alarms.common.add')"
      :cancelText="$t('alarms.common.cancel')"
    >
      <Form
        ref="addTagForm"
        :model="addTagForm"
        :label-width="100"
        :rules="ruleValidate"
      >
        <!-- 公司 -->
        <div v-if="company == 1">
          <FormItem :label="$t('alarm_contact.companyName')" prop="companyId">
            <Select
              v-model="addTagForm.companyId"
              style="width:300px;"
              placeholder=""
            >
              <Option
                :value="item.id"
                v-for="(item, index) in companyList"
                v-bind:key="index"
                >{{ item.name }}</Option
              >
            </Select>
          </FormItem>
        </div>
        <!-- 标签 -->
        <FormItem :label="$t('tag.tagName')" prop="keyName">
          <Input v-model="addTagForm.keyName" style="width:300px;" />
        </FormItem>
      </Form>
    </Modal>
  </div>
</template>
<script>
import { setCookie, getCookie } from "../../../../utils/cookieUtil.js";
import tableStandardTag from "../tag_management/TableStandardTag";
export default {
  name: "StandardTagSearch",
  components: {
    tableStandardTag
  },
  data() {
    return {
      company: getCookie(global.companyId),
      searchKey: "",
      addTagModalVisible: false,
      loadingAdd: true,
      companyList: [],
      companyIdSearch: "",
      addTagForm: {
        companyId: "",
        keyName: ""
      },
      ruleValidate: {
        companyId: [
          {
            required: true,
            message: "请选择公司",
            trigger: "change",
            type: "number"
          }
        ],
        keyName: [
          { required: true, message: "标签名称不能为空", trigger: "blur" }
        ]
      }
    };
  },
  mounted: function() {
    if (this.company == 1) {
      this.getCompanyDropDownBox();
    }
  },
  methods: {
    /****************** 查询 ******************************/

    // 查询
    search: function() {
      eventBus.$emit("searchKey", this.searchKey);
      tableStandardTag.methods.showAll();
    },
    changeCompany: function() {
      eventBus.$emit("companyIdSearch", this.companyIdSearch);
      tableStandardTag.methods.showAll();
    },
    /****************** 添加 ******************************/

    // 获取公司下拉框
    getCompanyDropDownBox: function() {
      this.$api.company
        .getCompanyDropDownBox("userName", getCookie(global.cookieName))
        .then(res => {
          this.companyList = res.data;
        });
    },
    // 添加标签
    addTagSubmit: function(name) {
      this.$refs[name].validate(valid => {
        if (valid) {
          const updateData = {
            companyId:
              this.addTagForm.companyId == null ||
              this.addTagForm.companyId == "" ||
              this.addTagForm.companyId == undefined
                ? this.company
                : this.addTagForm.companyId,
            keyName: this.addTagForm.keyName
          };
          this.$api.tag.addStandardTag(updateData).then(res => {
            setTimeout(() => {
              this.$refs[name].resetFields();
              this.loadingAdd = false;
              this.$nextTick(() => {
                this.loadingAdd = true;
              });
              this.$Message.success("添加成功");
              tableStandardTag.methods.showAll();
              this.addTagModalVisible = false;
            }, 1000);
          });
        } else {
          this.loadingAdd = false;
          setTimeout(() => {
            this.loadingAdd = true;
          }, 0);
          this.$Message.error("添加失败");
        }
      });
    },
    // 取消
    addTagReset: function(name) {
      this.addTagModalVisible = false;
      this.$refs[name].resetFields();
    }
  }
};
</script>
<style scoped></style>



// WEBPACK FOOTER //
// src/components/configuration/label_management/tag_management/StandardTagSearch.vue